import { useEffect, useState, useMemo } from 'react'
import { AdasBox, AdasButton, AdasTextField, AdasTypography } from '@components/wrapper-components'
import { PenLine } from 'lucide-react'

export const NoteForm = ({ cancel, submit, allowEdit = true, existingNote, label, noteType, maxLength, txAreaBgColor }) => {
  const [note, setNote] = useState(existingNote || '')
  const [isEdit, setIsEdit] = useState(!existingNote)

  useEffect(() => {
    setNote(existingNote || '')
  }, [existingNote])

  useEffect(() => {
    setIsEdit(!existingNote)
  }, [noteType])
  const handleChange = (e) => setNote(e.target.value)
  const handleSubmit = () => {
    submit(note)
    setIsEdit(false)
  }

  const handleCancel = () => {
    setIsEdit(false)
    cancel()
  }

  const internalNoteText = noteType === 'client_note' ? '* Internal Use Only: Not Shown on Invoice' : ''

  const sharedTextFieldStyles = {
    marginBottom: '0px',
    '.MuiInputBase-root': txAreaBgColor ? { backgroundColor: txAreaBgColor } : undefined,
    '.MuiInputBase-root.Mui-disabled': {
      color: 'black',
      WebkitTextFillColor: 'black'
    },
    '.MuiInputBase-input.Mui-disabled': {
      color: 'black',
      WebkitTextFillColor: 'black'
    }
  }

  const ActionButtons = useMemo(
    () => (
      <AdasBox className='overflow-auto my-[20px] mx-0' display='flex' alignItems='center' justifyContent='space-between'>
        <AdasTypography variant='subtitle2' className='font-semibold'>
          {internalNoteText}
        </AdasTypography>
        <AdasBox className='float-right'>
          {isEdit ? (
            <>
              <AdasButton variant='outlined' aria-label='cancel' color='primary' onClick={handleCancel} className='mr-[10px]'>
                Cancel
              </AdasButton>
              <AdasButton variant='contained' aria-label='save' color='primary' onClick={handleSubmit} disabled={!note?.trim()}>
                Save
              </AdasButton>
            </>
          ) : (
            allowEdit && (
              <AdasButton startIcon={<PenLine />} aria-label='edit note' color='primary' onClick={() => setIsEdit(true)}>
                Edit
              </AdasButton>
            )
          )}
        </AdasBox>
      </AdasBox>
    ),
    [isEdit, internalNoteText, allowEdit, note]
  )

  return (
    <AdasBox className={isEdit ? 'my-[15px] mx-[20px]' : 'my-[20px]'}>
      <AdasTypography variant='subtitle2' className='font-semibold'>
        {label}
      </AdasTypography>

      <AdasTextField
        multiline
        rows={4}
        name='note'
        id='note'
        value={isEdit ? note : existingNote}
        onChange={isEdit ? handleChange : undefined}
        fullWidth
        disabled={!isEdit}
        variant='outlined'
        helperText={isEdit ? `Maximum ${maxLength} Characters ${maxLength - note.length} remaining` : ''}
        className='mb-0'
        InputProps={{
          style: txAreaBgColor ? { backgroundColor: txAreaBgColor } : undefined,
          sx: {
            '&.Mui-disabled': { color: 'black', WebkitTextFillColor: 'black' },
            '& input.Mui-disabled': { color: 'black', WebkitTextFillColor: 'black' }
          }
        }}
        InputLabelProps={{ shrink: true }}
        inputProps={isEdit ? { maxLength } : {}}
      />

      {allowEdit && ActionButtons}
    </AdasBox>
  )
}
